import { Component } from 'react'
import { DataTable } from 'primereact/datatable';
import { BasicLazyParams } from '../../../utile';
import { baseUrlAdmin } from '../../../store/apiConstants';
import Service from '../../services';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import moment from 'moment';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import LoadingComponent from '../../loadingComponent';
import { Toast } from 'primereact/toast';
import BranchToSectionApprovalHierarchy from '../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';

class ReceiptModificationApproval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lazyParams: BasicLazyParams,
            searchLevel: '',
            receiptModifications: [],
            isLoading: false,
            showDialog: false,
            selectedReceipt: null,
            filteredReceipts: [],
            dropdownsData: null,
            defaultBranchData: null
        };
        this.service = new Service();
    }

    componentDidMount() {
    }

    onPage = (event) => {
        this.setState({
            lazyParams: {
                ...this.state.lazyParams,
                first: event.first,
                rows: event.rows,
                page: event.page
            }
        }, () => {
            this.filterReceipts();
        });
    };


    getReceiptModifications = () => {
        this.setState({ isLoading: true });
        const academicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/receipt-modification/get-receipt-modification`;

        const payload = {
            academicYear,
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            gradeId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            assignedHeirarchy: this.state?.dropdownsData?.heirarchy,

        };

        this.service.post(url, payload, true)
            .then(response => {
                if (response.status) {
                    this.setState({
                        receiptModifications: response.res.data || [],
                        totalRecords: response.res?.data?.length || 0,
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                    this.toast?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: response.errMessage || 'Failed to fetch receipt modifications',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching receipt modifications:', error);
                this.setState({ isLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch receipt modifications',
                    life: 3000
                });
            });
    };

    getStudentsInfo = () => {
        let { lazyParams, globalSearch } = this.state;
        this.setState({ isLoading: true, studentInfo: [] });
        const url = `${baseUrlAdmin}/transport-assign-approval/get-pending-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        let academicYear = localStorage.getItem('userAcademicYear');
        let username = this.state.searchType === 'studentName' ? this.state?.searchValue : '';
        let enrollmentNo = this.state.searchType === 'enrollmentNumber' ? this.state?.searchValue : '';

        let payload = {
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            gradeId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            academicYear: academicYear,
            assignedHeirarchy: this.state.dropdownsData.heirarchy
        };

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res?.records && res.res?.records?.length) {
                        this.setState({
                            isLoading: false,
                            studentInfo: res.res.records,
                            filteredUsers: res.res.records,
                            totalRecords: res.res.totalRecords
                        });
                    } else if (res.res?.records?.length == 0) {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'success', summary: 'No records found.', detail: '', life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occurred', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    setDropdownValues = (dropdownsData) => {
        this.setState(
            {
                dropdownsData,
                studentId: null,
                filteredUsers: [],
                totalRecords: 0,
                studentInfo: [],
            },
            () => {
                this.getReceiptModifications();
            }
        );
    };
    filterReceipts = () => {
        const { receiptModifications, dropdownsData, lazyParams } = this.state;
        if (!dropdownsData || !receiptModifications) return;

        // Filter the data based on dropdown selections
        const filtered = receiptModifications.filter(receipt => {
            return (!dropdownsData.branchIds || (Array.isArray(dropdownsData.branchIds) ? dropdownsData.branchIds.includes(receipt.branchId) : receipt.branchId === dropdownsData.branchIds)) &&
                (!dropdownsData.boardIds || (Array.isArray(dropdownsData.boardIds) ? dropdownsData.boardIds.includes(receipt.boardId) : receipt.boardId === dropdownsData.boardIds)) &&
                (!dropdownsData.classIds || (Array.isArray(dropdownsData.classIds) ? dropdownsData.classIds.includes(receipt.gradeId) : receipt.gradeId === dropdownsData.classIds)) &&
                (!dropdownsData.sectionId || receipt.sectionId === dropdownsData.sectionId);
        });

        // Calculate pagination
        const first = lazyParams.first;
        const rows = lazyParams.rows;
        const pagedData = filtered.slice(first, first + rows);

        this.setState({
            filteredReceipts: pagedData,
            totalRecords: filtered.length
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.dropdownsData !== this.state.dropdownsData ||
            prevState.receiptModifications !== this.state.receiptModifications) {
            this.filterReceipts();
        }
    }

    handleView = (rowData) => {
        this.setState({
            selectedReceipt: rowData,
            showDialog: true
        });
    };

    handleApprove = (isApproved) => {
        this.setState({ isLoading: true });
        const { selectedReceipt, dropdownsData } = this.state;
        let payload = {
            _id: selectedReceipt?._id,
            user_id: selectedReceipt?.user_id,
            modifiedFeeInfo: selectedReceipt.modifiedFeeInfo,
            academicYear: selectedReceipt?.academicYear,
            branchId: selectedReceipt?.branchId,
            handledBy: selectedReceipt?.handledBy || [],
            levelAndBranchDetails: dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == selectedReceipt.branchId),
            isApproved: isApproved,
            remarks: this.state.remarks || '',
        };

        payload.transactionId = selectedReceipt?.modifiedTransctionId && selectedReceipt?.modifiedTransctionId
        payload.approvalCode = selectedReceipt?.modifiedApprovalCode && selectedReceipt?.modifiedApprovalCode
        payload.cardNo = selectedReceipt?.modifiedCardNo && selectedReceipt?.modifiedCardNo
        payload.userBankName = selectedReceipt?.modifiedUserBankName && selectedReceipt?.modifiedUserBankName
        payload.rrNumber = selectedReceipt?.modifiedRrNumber && selectedReceipt?.modifiedRrNumber

        payload.chequeIssuedTo = selectedReceipt?.modifiedChequeIssuedTo && selectedReceipt?.modifiedChequeIssuedTo
        payload.chequeNo = selectedReceipt?.modifiedChequeNo && selectedReceipt?.modifiedChequeNo
        payload.chequeDate = selectedReceipt?.modifiedChequeDate && selectedReceipt?.modifiedChequeDate
        payload.bankName = selectedReceipt?.modifiedBankName && selectedReceipt?.modifiedBankName
        payload.bankBranchName = selectedReceipt?.modifiedBankBranchName && selectedReceipt?.modifiedBankBranchName
        payload.ddIssuedTo = selectedReceipt?.modifiedDdIssuedTo && selectedReceipt?.modifiedDdIssuedTo
        payload.ddNo = selectedReceipt?.modifiedDdNo && selectedReceipt?.modifiedDdNo
        payload.ddDate = selectedReceipt?.modifiedDdDate && selectedReceipt?.modifiedDdDate

        payload.modifiedFeeInfo = selectedReceipt?.modifiedFeeInfo?.filter((fee) => {
            return fee?.modifiedAmount && Number(fee?.modifiedAmount) >= 0;
        });
        this.setState({ isLoading: true });
        const url = `${baseUrlAdmin}/receipt-modification/approve-receipt-modification`;
        this.service.post(url, payload, true)
            .then((res) => {
                if (res && res.status) {
                    this.setState({ isLoading: false, showDialog: false, selectedReceipt: null, remarks: '' });
                    this.toast?.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: `Receipt ${isApproved ? 'approved' : 'rejected'} successfully`,
                        life: 3000
                    });
                    this.getReceiptModifications();
                } else {
                    this.setState({ isLoading: false });
                    this.toast?.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: res.message || 'Failed to process the request',
                        life: 3000
                    });
                }
            })
            .catch((error) => {
                console.error('Error approving receipt:', error);
                this.setState({ isLoading: false, showDialog: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to process the request',
                    life: 3000
                });
            });

    }


    actionBodyTemplate = (rowData) => {
        return (
            <Button
                style={{ backgroundColor: '#fff', border: 'none', padding: '0' }}
                onClick={() => this.handleView(rowData)} icon="pi pi-ellipsis-v" className=" p-button-text p-button-secondary ma-ml10" 
            ></Button>
        );
    };

    render() {
        console.log(this.state.selectedReceipt, 'selectedReceipt');
        return (
            <div className="ma-main">
                <div className=" datatable-crud-demo mx-2">
                    <div className="flex">
                        <BranchToSectionApprovalHierarchy selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} approvalType={'receiptModification'} />
                    </div>
                </div>

                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={this.state.filteredReceipts}
                    dataKey="id"
                    paginator
                    lazy
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}


                >
                    <Column
                        field='enrollmentId'
                        header="Enrollment No"
                        headerClassName="text-xl"
                        bodyClassName="text-lg text-left"
                    />
                    <Column
                        field='given_name'
                        header="Student Name"
                        headerClassName="text-xl"
                        bodyClassName="text-lg text-left"
                    />
                    <Column
                        field="receiptNo"
                        header="Receipt No"
                        headerClassName="text-xl"
                        bodyClassName="text-lg text-left"
                    />
                    <Column
                        field="receiptDate"
                        header="Receipt Date"
                        headerClassName="text-xl"
                        bodyClassName="text-lg text-left"
                        body={(rowData) => {
                            return <p>{moment(rowData.receiptDate).format('DD-MM-YYYY')}</p>
                        }}
                    />
                    <Column
                        field="requestRaisedDate"
                        header="Request Date"
                        headerClassName="text-xl"
                        bodyClassName="text-lg text-left"
                        body={(rowData) => {
                            return <p>{moment(rowData.requestRaisedDate).format('DD-MM-YYYY')}</p>
                        }}
                    />
                    <Column
                        header="Actions"
                        body={this.actionBodyTemplate}
                        headerClassName="text-xl"
                        bodyClassName="text-lg text-left"
                    />
                </DataTable>

                <Dialog
                    visible={this.state.showDialog}
                    style={{ width: '50vw' }}
                    header={<h4>Receipt Details</h4>}
                    headerClassName="text-center font-bold"
                    contentClassName="p-0"
                    className="receipt-dialog"
                    modal
                    onHide={() => this.setState({ showDialog: false })}
                    footer={
                        <div className="flex justify-content-end gap-2">

                            <Button label="Approve" icon="pi pi-check" style={{ backgroundColor: '#268900', border: 'none', borderRadius: '5px' }} onClick={() => this.handleApprove(true)} />
                            <Button label="Reject" icon="pi pi-times" style={{ backgroundColor: '#BF0031', border: 'none', borderRadius: '5px' }} onClick={() => this.handleApprove(false)} />
                        </div>
                    }
                    draggable={false}
                    resizable={false}
                >
                    {this.state.selectedReceipt && (
                        <>
                            <div className="px-4">
                                <div className="grid">
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2 min-w-max">Enrollment No:</label>
                                            <div>{this.state.selectedReceipt.enrollmentId}</div>
                                        </div>
                                    </div>
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2 min-w-max">Student Name:</label>
                                            <div>{this.state.selectedReceipt.given_name}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="grid">
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2 min-w-max">Receipt No:</label>
                                            <div>{this.state.selectedReceipt.receiptNo}</div>
                                        </div>
                                    </div>
                                    <div className="col-6 field mb-1">
                                        <div className="flex align-items-center">
                                            <label className="font-bold mr-2 min-w-max">Receipt Date:</label>
                                            <div>{moment(this.state.selectedReceipt.receiptDate).format('DD-MM-YYYY')}</div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <h5 className="mb-3 px-4 pb-2  border-bottom-1 border-gray-200" >Modified Changes</h5>
                                {(
                                    this.state.selectedReceipt?.modifiedTransctionId ||
                                    this.state.selectedReceipt?.modifiedTransactionDate ||
                                    this.state.selectedReceipt?.modifiedApprovalCode ||
                                    this.state.selectedReceipt?.modifiedCardNo ||
                                    this.state.selectedReceipt?.modifiedUserBankName ||
                                    this.state.selectedReceipt?.modifiedRrNumber
                                ) && (
                                        <div className="px-4">
                                            <div className="grid">
                                                {this.state.selectedReceipt?.modifiedTransctionId && (
                                                    <div className="col-6 field mb-1">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Transaction ID:</label>
                                                            <div>{this.state.selectedReceipt.modifiedTransctionId}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.selectedReceipt?.modifiedTransactionDate && (
                                                    <div className="col-6 field mb-1">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Transaction Date:</label>
                                                            <div>{moment(this.state.selectedReceipt.modifiedTransactionDate).format('DD-MM-YYYY')}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.selectedReceipt?.modifiedApprovalCode && (
                                                    <div className="col-6 field mb-1">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Approval Code:</label>
                                                            <div>{this.state.selectedReceipt.modifiedApprovalCode}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.selectedReceipt?.modifiedCardNo && (
                                                    <div className="col-6 field mb-1">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Card Number:</label>
                                                            <div>{this.state.selectedReceipt.modifiedCardNo}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.selectedReceipt?.modifiedUserBankName && (
                                                    <div className="col-6 field mb-1">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Bank Name:</label>
                                                            <div>{this.state.selectedReceipt.modifiedUserBankName}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                {this.state.selectedReceipt?.modifiedRrNumber && (
                                                    <div className="col-6 field mb-1">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">RR Number:</label>
                                                            <div>{this.state.selectedReceipt.modifiedRrNumber}</div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                {(this.state.selectedReceipt?.modifiedChequeIssuedTo ||
                                    this.state.selectedReceipt?.modifiedChequeNo ||
                                    this.state.selectedReceipt?.modifiedChequeDate ||
                                    this.state.selectedReceipt?.modifiedBankName ||
                                    this.state.selectedReceipt?.modifiedBankBranchName ||
                                    this.state.selectedReceipt?.modifiedDdIssuedTo ||
                                    this.state.selectedReceipt?.modifiedDdNo ||
                                    this.state.selectedReceipt?.modifiedDdDate) && (
                                        <div className="px-4">
                                            <div className="grid">
                                                {this.state.selectedReceipt?.modifiedChequeIssuedTo &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Cheque Issued To:</label>
                                                            <div>{this.state.selectedReceipt.modifiedChequeIssuedTo}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedChequeNo &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Cheque No:</label>
                                                            <div>{this.state.selectedReceipt.modifiedChequeNo}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedChequeDate &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Cheque Date:</label>
                                                            <div>{moment(this.state.selectedReceipt.modifiedChequeDate).format('DD-MM-YYYY')}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedDdIssuedTo &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">DD Issued To:</label>
                                                            <div>{this.state.selectedReceipt.modifiedDdIssuedTo}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedDdNo &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">DD No:</label>
                                                            <div>{this.state.selectedReceipt.modifiedDdNo}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedDdDate &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">DD Date:</label>
                                                            <div>{moment(this.state.selectedReceipt.modifiedDdDate).format('DD-MM-YYYY')}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedBankName &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Bank Name:</label>
                                                            <div>{this.state.selectedReceipt.modifiedBankName}</div>
                                                        </div>
                                                    </div>
                                                }
                                                {this.state.selectedReceipt?.modifiedBankBranchName &&
                                                    <div className="col-6 field mb-0">
                                                        <div className="flex align-items-center">
                                                            <label className="font-bold mr-2 min-w-max">Bank Branch Name:</label>
                                                            <div>{this.state.selectedReceipt.modifiedBankBranchName}</div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    )}

                                <div className="px-4">
                                    <div className="grid">
                                        {this.state.selectedReceipt?.modificationRemarks &&
                                            <div className="col-6 field mb-0">
                                                <div className="flex align-items-center">
                                                    <label className="font-bold mr-2 min-w-max">Remarks:</label>
                                                    <div>{this.state.selectedReceipt.modificationRemarks}</div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {this.state.selectedReceipt?.modifiedFeeInfo?.length > 0 && (
                                    <div className="mt-4 px-4">
                                        <DataTable value={this.state.selectedReceipt?.modifiedFeeInfo?.filter(item => item?.modifiedAmount) || []}>
                                            <Column field="feeType" header="Fee Type" body={(rowData) => rowData?.feeType || '-'} />
                                            <Column field="paymentTerm" header="Term" body={(rowData) => rowData?.paymentTerm || '-'} />
                                            <Column
                                                field="amountPaying"
                                                header="Original Amount"
                                                body={(rowData) => rowData?.amountPaying ? `${Number(rowData.amountPaying).toFixed(2)}` : '0.00'}
                                            />
                                            <Column
                                                field="modifiedAmount"
                                                header="Modified Amount"
                                                body={(rowData) => rowData?.modifiedAmount ? `${Number(rowData.modifiedAmount).toFixed(2)}` : '0.00'}
                                            />
                                            <Column
                                                header="Difference"
                                                body={(rowData) => {
                                                    if (!rowData?.modifiedAmount || !rowData?.amountPaying) return '0.00';
                                                    const diff = Number(rowData.modifiedAmount) - Number(rowData.amountPaying);
                                                    return <span >{`${Math.abs(diff).toFixed(2)}`}</span>;
                                                }}
                                            />
                                        </DataTable>

                                        <div className="flex justify-content-end my-4 p-4 border-round-lg bg-gray-50">
                                            <div className="flex gap-6">
                                                <div className="flex align-items-center gap-2">
                                                    <span className="font-bold text-sm" style={{ color: "#076EFF" }}>Total Original Amount:</span>
                                                    <span className="text-xl">₹{
                                                        (this.state.selectedReceipt?.modifiedFeeInfo || [])
                                                            .filter(item => item?.modifiedAmount)
                                                            .reduce((sum, item) => sum + Number(item?.amountPaying || 0), 0)
                                                            .toFixed(2)
                                                    }</span>
                                                </div>
                                                <div className="flex align-items-center gap-2">
                                                    <span className="font-bold text-sm" style={{ color: "#076EFF" }}>Total Modified Amount:</span>
                                                    <span className="text-xl">₹{
                                                        (this.state.selectedReceipt?.modifiedFeeInfo || [])
                                                            .filter(item => item?.modifiedAmount)
                                                            .reduce((sum, item) => sum + Number(item?.modifiedAmount || 0), 0)
                                                            .toFixed(2)
                                                    }</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="col-12 mt-4">
                                    <label className="label mb-2">
                                        Remarks<span className="ma-required">*</span>
                                    </label>
                                    <div className="mt-2">
                                        <ClassetTextArea
                                            className=""
                                            height="100px"
                                            width="100%"
                                            placeholder="Enter Remarks"
                                            value={this.state.remarks}
                                            onChange={(e) => this.setState({ remarks: e.target.value })}
                                        />
                                    </div>
                                </div>


                            </div>

                        </>
                    )}
                </Dialog>
                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}

            </div>

        )
    }
}

export default ReceiptModificationApproval